import { helper } from '@ember/component/helper';

export function getStrict([obj, index]: [
  Record<string, unknown | undefined> | unknown[] | undefined,
  string | number | undefined
]) {
  if (obj === undefined || index === undefined) {
    return;
  }

  if ((Array.isArray(obj) || typeof obj === 'string') && typeof index === 'number') {
    return obj[index];
  }

  if (typeof obj === 'object' && typeof index === 'string') {
    return (obj as any)[index];
  }

  if (typeof obj === 'number') {
    return obj;
  }
}
const getStrictHelper = helper(getStrict);

export default getStrictHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'get-strict': typeof getStrictHelper;
  }
}
